import { useLayout } from '@approvalmax/ui/src/components';
import { hocs as pageHocs } from 'modules/page';
import { memo } from 'react';
import { Helmet } from 'react-helmet';
import { routingService } from 'services/routing';

import { Layout } from '../layout';
import { useAccess } from '../resources/hooks/useAccess';
import { Widget } from './resources/components';
import { useBreadcrumbs } from './resources/hooks/useBreadcrumbs';
import { messages } from './resources/messages';

const Page = memo(() => {
    const hasAccess = useAccess();

    useLayout({ hasHeader: true, hasDrawer: true });
    useBreadcrumbs();

    if (!hasAccess) {
        routingService.pushToDefaultPath();

        return null;
    }

    return (
        <>
            <Helmet title={messages.title} />

            <Layout>
                <Widget />
            </Layout>
        </>
    );
});

Page.displayName = 'Page';

export default pageHocs.withProtected({ Page });
